import { getSession, setAuthCheckFailed, useGetAllProfileQuery } from '@onesource/services';
import type { ReactNode } from 'react';

type TAuthProviderProps = {
  children: ReactNode;
};

export const ProfileInfoProvider = (params: TAuthProviderProps) => {
  const { children } = params;
  const token = getSession();

  const { isError } = useGetAllProfileQuery({ token });

  if (isError) {
    setAuthCheckFailed();
  }

  return children;
};
